import * as yup from 'yup';
// Validations
export const caseFormValidationSchema = yup.object({
  ownerId: yup.string().required('Please select a owner'),
  channelName: yup.string().required('Please type a channel Name'),
  description: yup.string().required('Please type a description'),
});
